export default __webpack_public_path__ + "static/media/icon_red_farmacias_on.e7f19655.svg";